import { render, staticRenderFns } from "./company-settings.vue?vue&type=template&id=9b0ff24a&"
import script from "./company-settings.vue?vue&type=script&lang=js&"
export * from "./company-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports